import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";

const NEW_REPORT_PATTERNS = [
  "/report-builder/new",
  "/report-builder/multi-table/new",
];

const REPORT_ID_PATTERNS = [
  "/report-builder/multi-table/:reportId/edit",
  "/report-builder/:reportId/edit",
  "/report-builder/:reportId/*",
];

export const useReportBrowserTitle = (savedReports) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Undefined while the saved-reports query is loading or has errored; the
    // current title is left in place rather than flashing a wrong fallback.
    if (savedReports === undefined) {
      return;
    }

    let name;
    if (NEW_REPORT_PATTERNS.some((pattern) => matchPath(pattern, pathname))) {
      name = "New Report";
    } else {
      for (const pattern of REPORT_ID_PATTERNS) {
        const match = matchPath(pattern, pathname);
        if (match) {
          const { reportId } = match.params;
          name =
            savedReports.find((r) => r.internalName === reportId)
              ?.displayName ?? "New Report";
          break;
        }
      }
    }

    if (name === undefined) {
      return;
    }
    document.title = `${name} - Cactus`;
  }, [pathname, savedReports]);
};
